import React from 'react';
import loadable from '@loadable/component';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const fallbackPrivacy = `


*Last Updated: October 4, 2026*

Your privacy is as important to us as your safety on the trails. Here is how we handle your data:

**1. Information We Collect**
*   **Account Data:** When you sign up, we collect your name, email address, and general location (e.g., your local SoCal zip code) to facilitate local transactions.
*   **Listing Data:** Photos, descriptions, and prices of the items you post.
*   **Communications:** Messages sent between buyers and sellers on our platform to help prevent fraud and maintain community safety.

**2. How We Use Your Information**
We use your data strictly to keep the marketplace running smoothly. This includes helping you find nearby bikes and parts, sending you account notifications, and investigating suspicious activities to keep our community free of scammers.

**3. Sharing Your Information**
We do not sell your personal data to third-party marketers. We only share information when absolutely necessary, such as with trusted service providers who host our platform, or if required by law enforcement. 

**4. Location Privacy**
While we use your location to show you local listings, we never display your exact address to other users. Only your general vicinity (e.g., neighborhood or city) is shown on your listings. You choose where and when to disclose exact meeting locations via private messaging.

**5. Your Data Rights**
You have the right to access, update, or delete your account and personal information at any time. If you choose to leave the community, simply delete your account in your profile settings, and your listings and personal data will be removed from public view.
`;

export const fallbackSections = {
  sections: [
    {
      sectionType: 'article',
      sectionId: 'privacy',
      appearance: { fieldType: 'customAppearance', backgroundColor: '#ffffff' },
      title: { fieldType: 'heading1', content: 'Privacy Policy' },
      blocks: [
        {
          blockType: 'defaultBlock',
          blockId: 'hero-content',
          text: {
            fieldType: 'markdown',
            content: fallbackPrivacy,
          },
        },
      ],
    },
  ],
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: 'Privacy Policy',
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content: 'Privacy policy for our emoto marketplace',
    },
  },
};

const FallbackPage = props => {
  return <PageBuilder pageAssetsData={fallbackSections} {...props} />;
};

export default FallbackPage;
